import {
  messaging as firebaseMessaging,
  fcmUnsupported,
  vapid_key,
} from "../globs/utils/firebase";
import ajaxProxy from "../globs/ajax-proxy";
import config from "../globs/config";

// import { ProgressPlugin } from 'webpack';
// import environmentVariables from '../globs/utils/get-environment-variables';
import initialize from "../globs/utils/firebase";

export const NOTIFICATIONS_PERMISSION = "notifications/permission";
export const SET_IS_SUBSCRIBED = "notifications/set-is-subscribed";

// Subscribe to notifications when permission is already granted
export function subscribeWithExistingPermission(user) {
  return async (dispatch) => {
    try {
      if (fcmUnsupported) {
        console.log("FCM not supported on this device");
        return;
      }

      const permission = Notification.permission;
      console.log("Current notification permission:", permission);

      if (permission === "granted") {
        // Wait for service worker to be ready before initializing Firebase
        if ('serviceWorker' in navigator) {
          await navigator.serviceWorker.ready;
        }
        await initialize();
        dispatch(webPushSendSubscription(user));
      } else {
        console.log("Notification permission not granted, skipping subscription");
      }
    } catch (e) {
      console.error("Failed to subscribe to notifications", e);
    }
  };
}

// Subscribe to notifications (assumes permission already granted)
// This should be called AFTER permission is confirmed granted
export default function subscribeNotifications(user) {
  return async (dispatch) => {
    try {
      if (fcmUnsupported) {
        console.log("FCM not supported on this device");
        return;
      }

      // Check permission status
      const permission = Notification.permission;
      dispatch(setNotificationPermission(permission));

      if (permission === "granted") {
        // Wait for service worker to be ready before initializing Firebase
        if ('serviceWorker' in navigator) {
          await navigator.serviceWorker.ready;
        }
        await initialize(); // Initialize Firebase after permission is granted and SW is ready
        dispatch(webPushSendSubscription(user));
      } else {
        console.log("Notification permission not granted.");
      }
    } catch (e) {
      console.error("Failed to initialize FCM", e);
    }
  };
}

export function unsubscribeNotifications(user) {
  return new Promise((resolve) => {
    const messaging = firebaseMessaging();
    console.log("messaging", messaging);
    if (messaging) {
      messaging
        .getToken()
        .then((currentToken) => {
          if (currentToken) {
            const salesOfficerId = user.id;
            const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/push_subscriptions/destroy`;
            console.log("currentToken", currentToken);
            ajaxProxy
              .webPushUnsubscribe({
                subscription: currentToken,
                targetUrl: url,
              })
              .then(() => {
                resolve(true);
              })
              .catch(() => {
                resolve(true);
              });
          } else {
            // Show permission request.
            console.log("No Instance ID token available.");
            resolve(true);
          }
        })
        .catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
          resolve(true);
        });
    } else {
      resolve(true);
    }
  });
}

function getNotificationPermission(user) {
  return (dispatch) => {
    if (!fcmUnsupported) {
      Notification.requestPermission().then((permission) => {
        console.log("🟩 Permission result:", permission);
        dispatch(setNotificationPermission(permission));
        if (permission === "granted") {
          console.log("🟩 Permission granted, calling webPushSendSubscription");
          dispatch(webPushSendSubscription(user));
        } else {
          console.warn("🟥 Permission denied");
          console.log("Notification permission not granted:", permission);
        }
      });
    }
  };
}

function setNotificationPermission(permission) {
  return {
    type: NOTIFICATIONS_PERMISSION,
    payload: {
      permission,
    },
  };
}

function webPushSendSubscription(user) {
  return async (dispatch) => {
    console.log("🟩 Entering webPushSendSubscription");
    // Get Instance ID token. Initially this makes a network call, once retrieved
    // subsequent calls to getToken will return from cache.
    const messaging = firebaseMessaging();
    if (!messaging) {
      console.warn("🟥 Firebase messaging is null");
      return;
    }
    console.log(
      "messaging from firebaseMessaging() in firebase-notifications.js",
      messaging
    );
    if (messaging) {
      try {
        const salesOfficerId = user.id;
        const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/push_subscriptions`;

        // Wait for service worker to be ready
        const registration = await navigator.serviceWorker.ready;

        messaging
          .getToken({
            vapidKey: vapid_key,
            serviceWorkerRegistration: registration,
          })
          .then((currentToken) => {
            console.log("🟩 Got FCM token:", currentToken);
            if (currentToken) {
              ajaxProxy
                .webPushSubscribe({
                  subscription: currentToken,
                  targetUrl: url,
                })
                .then(() => {
                  dispatch(setIsSubscribed(true));
                });
              // updateUIForPushEnabled(currentToken);
            } else {
              // Show permission request.
              console.log(
                "No Instance ID token available. Request permission to generate one."
              );
              // Show permission UI.
              // updateUIForPushPermissionRequired();
              dispatch(setIsSubscribed(false));
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
            // showToken('Error retrieving Instance ID token. ', err);
            dispatch(setIsSubscribed(false));
          });

        // Callback fired if Instance ID token is updated.
        messaging.onTokenRefresh(async () => {
          try {
            const registration = await navigator.serviceWorker.ready;
            messaging
              .getToken({
                vapidKey: vapid_key,
                serviceWorkerRegistration: registration,
              })
              .then((refreshedToken) => {
                // Indicate that the new Instance ID token has not yet been sent to the
                // app server.
                dispatch(setIsSubscribed(false));
                // Send Instance ID token to app server.
                if (refreshedToken) {
                  ajaxProxy
                    .webPushSubscribe({
                      subscription: refreshedToken,
                      targetUrl: url,
                    })
                    .then(() => {
                      dispatch(setIsSubscribed(true));
                    });
                }
                // ...
              })
              .catch((err) => {
                console.log("Unable to retrieve refreshed token ", err);
                // showToken('Unable to retrieve refreshed token ', err);
                dispatch(setIsSubscribed(true));
              });
          } catch (error) {
            console.error("Error in onTokenRefresh:", error);
          }
        });
      } catch (error) {
        console.log("An error occurred while retrieving token. ", error);
        dispatch(setIsSubscribed(false));
      }
    }
  };
}

function setIsSubscribed(isSubscribed) {
  return {
    type: SET_IS_SUBSCRIBED,
    payload: {
      isSubscribed,
    },
  };
}
